import React from 'react';

function ucFirst(str = '') {
  return str.charAt(0).toUpperCase() + str.substring(1);
}

function getStatusLabel(status = 'Unknown') {
  return ucFirst(status);
}

function getStatusClassNames(status) {
  return status === 'delivered' ? 'badge badge-success' : 'badge badge-warning';
}

export default props => (
  <span className={getStatusClassNames(props.status)}>
    {getStatusLabel(props.status)}
  </span>
);



// WEBPACK FOOTER //
// ./src/components/orders/ShippingStatus.js